import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LoadingButton } from "@mui/lab";
import {
  Alert,
  Box,
  FormHelperText,
  IconButton,
  InputAdornment,
  Snackbar,
  TextField,
} from "@mui/material";
import Iconify from "../../components/iconify";
import logo from "../../Assets/Images/logo-faqeer.png";
import { Login } from "../../DAL/Auth/Auth";
import { enqueueSnackbar } from "notistack";

const LoginSection = () => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [inputs, setInputs] = useState({
    email: "",
    password: "",
  });
  const handleShowPassword = () => {
    setShowPassword((show) => !show);
  };
  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((prev) => ({ ...prev, [name]: value }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const data = {
      email: inputs?.email,
      password: inputs?.password,
    };
    const response = await Login(data);
    if (response.statusCode == 200) {
      localStorage.setItem("admin_token", response?.accessToken);
      localStorage.setItem("admin_data", JSON.stringify(response?.data));
      setIsLoading(false);
      // enqueueSnackbar(response.message, { variant: "success" });
        navigate("/dashboard")
      
    } else {
      setIsLoading(false);
      if (typeof response.message == "string") {
        enqueueSnackbar(response.message, { variant: "error" });
      } else {
        setError(response?.message);
        enqueueSnackbar("Invalid credentials", { variant: "error" });
      }
    }
  };



  return (
    <>
     <form onSubmit={handleSubmit}>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
       
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "15px",
            border: "0.5px solid silver",
            width: { lg: "25%", md: "40%", sm: "70%", xs: "90%" },
            padding: "30px 30px 50px 30px",
            borderRadius: "13px",
          }}
        >
          
          <div style={{ display: "flex", justifyContent: "center" }}>
            <img src={logo} alt="" width={130} />
          </div>
          <TextField
            size="small"
            name="email"
            onChange={handleChange}
            label="Email *"
            fullWidth
            sx={{
              "& .MuiOutlinedInput-root": {
                "&:hover fieldset": {
                  borderColor: "#cc1919",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#cc1919",
                },
              },
              "& .MuiInputLabel-root": {
                "&.Mui-focused": {
                  color: "#cc1919",
                },
              },
            }}
          />
          <FormHelperText sx={{ color: "red" }}>
            {error?.email && error?.email[0]}
          </FormHelperText>
          <TextField
            size="small"
            fullWidth
            onChange={handleChange}
            name="password"
            label="Password *"
            type={showPassword ? "text" : "password"}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={handleShowPassword} edge="end">
                    <Iconify
                      icon={showPassword ? "eva:eye-fill" : "eva:eye-off-fill"}
                    />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            sx={{
           
              "& .MuiOutlinedInput-root": {
                "&:hover fieldset": {
                  borderColor: "#cc1919",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#cc1919",
                },
              },
              "& .MuiInputLabel-root": {
                "&.Mui-focused": {
                  color: "#cc1919",
                },
              },
            }}
          />
          <FormHelperText sx={{ color: "red" }}>
            {error?.password && error?.password[0]}
          </FormHelperText>
          <LoadingButton
            fullWidth
            size="medium"
            style={{
              borderRadius: "30px",
              padding: "10px 10px",
              backgroundColor: "#CC1919",
              display: "flex",
              gap: "10px",
              textTransform: "none",
           
            }}
            variant="contained"
            type="submit"
            loading={isLoading}
          >
            {"Login"}
            <Iconify
              icon={"mdi:login"}
              sx={{ height: 20, width: 20, marginLeft: "4px" }}
            />
          </LoadingButton>
        </Box>
      </div>
          </form>
    </>
  );
};

export default LoginSection;
